import styled from "styled-components";
import { colors, values, text } from "../../theme/constants";

export const ChipContainer = styled.div`
    border-radius: 30px;
    font-size: 18px;
    white-space: nowrap;
    flex-shrink: 0;
    margin-right: 8px;
    color: ${colors.LAYOUT.GRAY[1000]};
    border: 1px solid
        ${(props) =>
            props.selected
                ? colors.BRAND.PRIMARY[1000]
                : colors.LAYOUT.GRAY[400]};
    background-color: ${(props) =>
        props.selected ? colors.BRAND.PRIMARY[200] : colors.WHITE};
    padding: 6px 8px 6px 8px;
    display: flex;
    flex-direction: row;
    font-weight: ${text.REGULAR.WEIGHT};
    font-family: ${text.REGULAR.FONT};
    align-items: center;
    transition: ${values.DEFAULT_TRANSITION_DURATION};
    cursor: pointer;

    &:hover {
        border-color: ${colors.BRAND.PRIMARY[1000]};
    }
`;

export const TextContainer = styled.div`
    ${(props) => (props.selected ? `color: ${colors.BLACK};` : "")}
    margin-left: 8px;
`;
